var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.774 24.5382C12.774 23.1215 11.9286 21.8378 10.6293 21.2742C7.76456 20.0219 5.75297 17.1572 5.75297 13.8306C5.75297 10.5041 7.76456 7.63931 10.6293 6.38696C11.9286 5.81558 12.774 4.53975 12.774 3.12303V0.0078125C5.63557 0.563542 0 6.55133 0 13.8306C0 21.1099 5.63557 27.0977 12.774 27.6534V24.5382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8734 0V3.10738C15.8734 4.53193 16.7266 5.80776 18.0337 6.37914C20.9141 7.62366 22.9335 10.4962 22.9335 13.8306C22.9335 17.165 20.9141 20.0297 18.0337 21.2821C16.7266 21.8456 15.8734 23.1293 15.8734 24.5538V27.6612C23.0274 27.1211 28.6865 21.1255 28.6865 13.8306C28.6865 6.53568 23.0274 0.547901 15.8734 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboLogoNoText);
export default __webpack_public_path__ + "static/media/fbo-logo-no-text.3b2177c12ed6320df1cc474d9577cd25.svg";
export { ForwardRef as ReactComponent };